// extracted by mini-css-extract-plugin
export default {"add_button":"Resources_add_button__IXZNy","resources":"Resources_resources__LmxVe"};